<template>
  <div v-if="this.$store.state.timers.pollTimer.pollId === pollId">
    {{ getTimer }}
  </div>
</template>
<script>
export default {
  computed: {
    getTimer() {
      return this.$store.state.timers.pollTimer.timerString;
    }
  },
  props: {
    pollId: String
  }
};
</script>
